module.exports = __webpack_public_path__ + "img/8.45c2e7c0.svg";